import styled from 'styled-components';
import { theme } from '../../configs';

const ContainerFull = styled.div`
  margin-left: ${theme.size.space * 2}px;
  margin-right: ${theme.size.space * 2}px;
`;

export default ContainerFull;
